import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { useProducts } from '@/hooks/useProducts';
import { displaySize } from '@/utils/displaySize';

export const CartItemsList = ({ cartItems, text, labels }) => {
  const { tLabels, hLabels, cLabels } = labels;
  const { language } = useLanguage();
  const { products } = useProducts();
  const localize = (item) => {
    const live = products.find(p => p.id === item.id);
    return {
      name: live?.name || item.name,
      colorName: item.selectedColor
        ? (live?.colors?.find(c => c.value === item.selectedColor.value)?.name || item.selectedColor.name)
        : null,
    };
  };
  return (
    <div>
      <h3 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
        <ShoppingCart className="w-4 h-4" /> {text.cart}
      </h3>
      {cartItems.length === 0 ? (
        <p className="text-slate-500 text-sm" data-testid="empty-cart-msg">{text.empty}</p>
      ) : (
        <div className="space-y-2">
          {cartItems.map((item) => {
            const loc = localize(item);
            return (
            <div key={`${item.id}-${item.size}-${item.selectedTradition || ''}-${item.selectedHilos || ''}-${item.selectedColor?.value || ''}`} className="flex items-start gap-4 p-3 bg-slate-50 rounded-lg" data-testid={`cart-item-${item.id}`}>
              <img src={item.image} alt={loc.name} className="w-14 h-14 object-contain rounded bg-white flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-medium text-slate-800 text-sm truncate">{loc.name}</p>
                <div className="flex flex-wrap gap-x-2 gap-y-0.5 text-xs text-slate-500 mt-1">
                  <span>{text.size}: {displaySize(item.size || item.selectedSize, language)}</span>
                  {item.selectedColor && <span>| {text.color}: {loc.colorName}</span>}
                  {item.selectedTradition && !item.noTzitzit && <span>| {text.tradition}: {tLabels[item.selectedTradition]}</span>}
                  {item.selectedHilos && !item.noTzitzit && <span>| {text.threads}: {hLabels[item.selectedHilos]}</span>}
                  {item.selectedCottonType && item.hasCottonType && <span>| {text.cottonType}: {cLabels[item.selectedCottonType]}</span>}
                  <span>| {text.qty}: {item.quantity}</span>
                </div>
              </div>
              <p className="font-bold text-cyan-600 text-sm whitespace-nowrap">${(item.price * item.quantity).toFixed(2)}</p>
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
